import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "componentsPage/Grid/GridContainer.js";
import GridItem from "componentsPage/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles } from '@mui/styles';

import officeStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/officeStyle.js";

// office
import office2 from "assets/img/notaria11bga1.jpeg";
import office1 from "assets/img/notaria11bga2.jpeg";

const useStyles = makeStyles(officeStyle);

export default function SectionOffice({...rest}) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.office}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} className={classes.textCenter}>
              <h2 className={classes.title}>Nuestra Oficina</h2>
              <h4 className={classes.description}>
                Tenemos un ambiente adecuado para que usted realice sus trámites.
              </h4>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem md={6} sm={10}>
              <img
                className={classNames(
                  classes.imgRaised,
                  classes.imgFluid,
                  classes.rounded
                )}
                src={office1}
                alt="Sitio de las oficinas de la Notaría 11 de Bucaramanga"
              />
            </GridItem>
            <GridItem md={6} sm={10}>
              <img
                className={classNames(
                  classes.imgRaised,
                  classes.imgFluid,
                  classes.rounded
                )}
                src={office2}
                alt="Entrada de las oficinas de la Notaría 11 de Bucaramanga"
              />
            </GridItem>
          </GridContainer>
          </div>
      </div>
       </div>
  );
}
